export const ALLIES = [
  { name: "La Giralda", logo: "/assets/allies/la-giralda.jpg" },
  { name: "Shell", logo: "/assets/allies/shell.jpg" },
  { name: "Qualid", logo: "/assets/allies/qualid.jpg" },
  { name: "Disbattery Lubricantes", logo: "/assets/allies/disbattery.jpg" },
];
